import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

import styled from 'styled-components'

const ButtonText = styled.span`
  margin-right: 10px;
`

function NewHitlistButton({ ids, action, className }) {
  const disabled = ids.length === 0

  return (
    <form action={action} method="post" target="_blank">
      <input type="hidden" name="ids" value={ids.join(',')} />
      <Button
        className={className}
        bsStyle="primary"
        type="submit"
        disabled={disabled}>
        <ButtonText>New Hitlist</ButtonText>
        <FontAwesome name="list-alt" />
      </Button>
    </form>
  )
}

NewHitlistButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
  action: PropTypes.string,
  className: PropTypes.string,
}

NewHitlistButton.defaultProps = {
  ids: [],
  action: '/hitlist/',
}

export default NewHitlistButton
